import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { ResponseManagement } from '../components/responseManagement';

export const getResponseManagementInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    responseManagement: {
      path: `${basePath}/response-management/dashboard`,
      url: `${baseUrl}/response-management/dashboard`,
      documentTitle: 'Response Management',
    },
  };
};

export const getResponseManagementInternalRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getResponseManagementInternalRoutesConfig(basePath, baseUrl);

  return {
    responseManagement: (
      <Route exact path={config.responseManagement.path}>
        <Page routeDefinition={config.responseManagement}>
          <ResponseManagement />
        </Page>
      </Route>
    ),
  };
};
